import { useCallback, useRef } from 'react';
import { useLayoutEffect } from './useLayoutEffect';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useEffectEventPatch(fn) {
    const ref = useRef(null);
    useLayoutEffect(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return useCallback((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}

//# sourceMappingURL=useEffectEvent.js.map